import { StrictMode, Fragment } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { AuthLayout } from './components/auth-layout/auth-layout';
import { Notifications } from '@servicetitan/notifications';

import 'semantic-ui-css/semantic.min.css';
import './design-system.css';

export const App = () => (
    <BrowserRouter>
        <StrictMode>
            <Notifications>
                <Fragment>
                    <Route path="/" children={<AuthLayout />} />
                </Fragment>
            </Notifications>
        </StrictMode>
    </BrowserRouter>
);
